module.exports = __webpack_public_path__ + "img/route.3b3b0198.svg";